import { z } from 'zod';
export const assetStatusEnum = z.enum(['active', 'inactive', 'under_maintenance', 'decommissioned']);
export const createAssetSchema = z.object({
    name: z.string().trim().min(1, 'Asset name is required'),
    description: z.string().optional(),
    asset_code: z.string().optional(),
    site_id: z.string().uuid().optional(),
    location_id: z.string().uuid().optional(),
    category_id: z.string().uuid().optional(),
    status: assetStatusEnum.optional(),
    serial_number: z.string().optional(),
    model: z.string().optional(),
    manufacturer: z.string().optional(),
    purchase_date: z.string().optional(),
    purchase_cost: z.number().min(0).optional(),
    warranty_expiry: z.string().optional(),
    notes: z.string().optional(),
    metadata: z.record(z.unknown()).optional(),
});
export const updateAssetSchema = createAssetSchema.partial();
//# sourceMappingURL=asset.schemas.js.map